import {
    BankOutlined,
    CheckCircleFilled,
    CreditCardOutlined,
    EditOutlined,
    FilePdfOutlined,
    InfoCircleOutlined,
    MailOutlined
} from '@ant-design/icons';
import { Button, Dropdown, List, Menu, Popconfirm, Popover, Space, Tag, Tooltip } from 'antd';
import { calculateAward } from '../utils/Utils';
import { countryCodes } from './CountryCodePhone';

const getCountry = (performer) => {
    if (performer.country) return performer.country;

    let codeStr = "";
    if (performer.countryCode) {
        codeStr = String(performer.countryCode).trim();
    } else if (performer.phoneNumber) {
        codeStr = String(performer.phoneNumber).trim();
    }

    if (!codeStr) return "-";
    if (!codeStr.startsWith('+')) {
        codeStr = '+' + codeStr;
    }

    const sortedCodes = [...countryCodes].sort((a, b) => b.code.length - a.code.length);
    const matched = sortedCodes.find(c => codeStr.startsWith(c.code));
    if (matched) {
        const match = matched.name.match(/\(([^)]+)\)/);
        return match ? match[1] : matched.name;
    }
    return "-";
};
export const RegistrantsColumns = [
    {
        title: 'Name',
        dataIndex: 'name',
    },
    {
        title: 'Achievement',
        dataIndex: 'achievement',
    },
    {
        title: 'Category',
        dataIndex: 'category',
    },
    {
        title: 'City',
        dataIndex: 'city',
    },
    {
        title: 'Teacher',
        dataIndex: 'teacher',
    },
    {
        title: 'Duration',
        dataIndex: 'duration',
    },
];

export const getRegistrants2025Columns = (getScoreData, getAgeCategoryLabel, handleDownloadPDF, handleUpdateStatus, showEditModal, handleDelete, handleViewVideo, handleDownloadVideo, handleOpenUploadModal, showManageScoreModal, handleResendEmail, resendingId, handleSendPaymentRequestBank, handleSendPaymentRequestPaynow, sendingPaymentId, handleSendPaymentInfoOptions, sendingPaymentInfoId, handleOpenCustomPaymentInfoModal, handleOpenAdminNoteModal) => [
    { title: "Parent Name", dataIndex: "name" },
    { title: "Teacher Name", dataIndex: "teacherName" },
    { title: "Total Performer", dataIndex: "totalPerformer" },
    { title: "Competition Category", dataIndex: "competitionCategory" },
    { title: "Performance Category", dataIndex: "PerformanceCategory" },
    {
        title: "Phone Number",
        dataIndex: "performers",
        render: (performers) => {
            if (Array.isArray(performers)) {
                return performers.map((p, i) => {
                    const countryCode = p.countryCode || '+62';
                    const number = p.phoneNumber || '';
                    return <div key={i}>{i + 1}. {String(countryCode)} {String(number)}</div>;
                });
            }
            return "-";
        },
    },
    { title: "Payment Status", dataIndex: "paymentStatus" },
    { title: "Invoice Status", dataIndex: "invoiceStatus" },
    // { title: "Birth Cert", dataIndex: "birthCertS3Link" },
    {
        title: "Performers",
        dataIndex: "performers",
        render: (performers) => {
            if (Array.isArray(performers)) {
                return performers.map((p, i) => (
                    p.firstName ? (
                        <div key={i}>{i + 1}. {p.firstName} {p.lastName}</div>
                    ) : (
                        <div key={i}>{i + 1}. {p.fullName}</div>
                    )
                ));
            }
            return "-";
        },
    },
    {
        title: "Performers Email",
        dataIndex: "performers",
        render: (performers) => {
            if (Array.isArray(performers)) {
                return performers.map((p, i) => (
                    <div key={i}>{i + 1}. {p.email}</div>
                ));
            }
            return "-";
        },
    },
    {
        title: "Country",
        dataIndex: "performers",
        render: (performers) => {
            if (Array.isArray(performers)) {
                return performers.map((p, i) => (
                    <div key={i}>{i + 1}. {getCountry(p)}</div>
                ));
            }
            return "-";
        },
    },
    { title: "YouTube Link", dataIndex: "youtubeLink" },
    { title: "Repertoire Title", dataIndex: "repertoireTitle" },
    {
        title: "Age Category", dataIndex: "ageCategory", render: (ageCategory) => {


            return getAgeCategoryLabel(ageCategory, "", "");
        },
    },
    { title: "Instrument Category", dataIndex: "instrumentCategory" },
    {
        title: "Created At", dataIndex: "createdAt",
        sorter: (a, b) => {
            const timeA = a.createdAt?.seconds || 0;
            const timeB = b.createdAt?.seconds || 0;
            return timeA - timeB;
        },
        render: (createdAt) => {
            if (createdAt?.seconds) {
                const date = new Date(createdAt.seconds * 1000);
                return date.toLocaleString();
            }
            return "-";
        },
    },

    { title: "Remark", dataIndex: "remark" },
    {
        title: "Admin Note",
        dataIndex: "adminNote",
        render: (text, record) => (
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', minWidth: 150 }}>
                <span style={{ whiteSpace: 'pre-wrap' }}>{text || '-'}</span>
                <Button type="link" onClick={() => handleOpenAdminNoteModal(record)}>
                    Edit
                </Button>
            </div>
        )
    },
    {
        title: 'Actions',
        key: 'actions',
        // The render function now calls the handlers passed as arguments
        render: (text, record) => (
            <div>
                <Button type="link" onClick={() => handleDownloadPDF(record)}>
                    Download PDF
                </Button>

                <Button type="primary" onClick={() => handleUpdateStatus(record)}>
                    Mark as Paid
                </Button>
            </div>
        ),
    },
    {
        title: 'Actions',
        key: 'actions',
        render: (_, record) => (
            <Space size="middle">
                <Button type="link" onClick={() => showEditModal(record)}>
                    Edit
                </Button>

                <Button
                    type="link"
                    danger
                    onClick={() => handleDelete(record)}
                >
                    Delete
                </Button>
                {/* <Button type="link" onClick={() => showManageScoreModal(record)}>
                    Manage Score
                </Button> */}
                <Tooltip title="Resend registration confirmation email">
                    <Button
                        type="link"
                        icon={<MailOutlined />}
                        loading={resendingId === record.id}
                        onClick={() => handleResendEmail(record)}
                        style={{ color: '#1890ff' }}
                    >
                        Resend Email
                    </Button>
                </Tooltip>

                <Dropdown
                    overlay={
                        <Menu>
                            <Menu.ItemGroup title="Live">
                                <Menu.Item
                                    key="bank"
                                    icon={<BankOutlined />}
                                    onClick={() => handleSendPaymentRequestBank(record, false)}
                                >
                                    Bank Transfer
                                </Menu.Item>
                                <Menu.Item
                                    key="paynow"
                                    icon={<CreditCardOutlined />}
                                    onClick={() => handleSendPaymentRequestPaynow(record, false)}
                                >
                                    PayNow
                                </Menu.Item>
                            </Menu.ItemGroup>
                            <Menu.Divider />
                            <Menu.ItemGroup title="Test (Demo)">
                                <Menu.Item
                                    key="test_bank"
                                    icon={<BankOutlined />}
                                    onClick={() => handleSendPaymentRequestBank(record, true)}
                                >
                                    Test Bank Transfer
                                </Menu.Item>
                                <Menu.Item
                                    key="test_paynow"
                                    icon={<CreditCardOutlined />}
                                    onClick={() => handleSendPaymentRequestPaynow(record, true)}
                                >
                                    Test PayNow
                                </Menu.Item>
                            </Menu.ItemGroup>
                            <Menu.Divider />
                            <Menu.ItemGroup title="Payment Info (Both Options)">
                                <Menu.Item
                                    key="payment_info_live"
                                    icon={<InfoCircleOutlined />}
                                    onClick={() => handleSendPaymentInfoOptions(record, false)}
                                >
                                    Send Payment Info
                                </Menu.Item>
                                <Menu.Item
                                    key="payment_info_test"
                                    icon={<InfoCircleOutlined />}
                                    onClick={() => handleSendPaymentInfoOptions(record, true)}
                                    style={{ color: '#13c2c2' }}
                                >
                                    Test Payment Info
                                </Menu.Item>
                            </Menu.ItemGroup>
                            <Menu.Divider />
                            <Menu.ItemGroup title="Custom Payment Info">
                                <Menu.Item
                                    key="custom_payment_info_live"
                                    icon={<EditOutlined />}
                                    onClick={() => handleOpenCustomPaymentInfoModal(record, false)}
                                >
                                    Send Custom Payment Info
                                </Menu.Item>
                                <Menu.Item
                                    key="custom_payment_info_test"
                                    icon={<EditOutlined />}
                                    onClick={() => handleOpenCustomPaymentInfoModal(record, true)}
                                    style={{ color: '#13c2c2' }}
                                >
                                    Test Custom Payment Info
                                </Menu.Item>
                            </Menu.ItemGroup>
                        </Menu>
                    }
                    trigger={['click']}
                >
                    <Button
                        type="link"
                        loading={sendingPaymentId === record.id || sendingPaymentInfoId === record.id}
                        style={{ color: '#faad14' }}
                    >
                        Payment Request
                    </Button>
                </Dropdown>
            </Space>
        ),
    },
    {
        title: "Performance Video",
        key: "video",
        render: (_, record) => {
            // Check if there is a YouTube link OR an S3 video file
            const hasVideo = record.youtubeLink || record.videoPerformanceS3Link;

            if (!hasVideo) return "-";

            return (
                <Space>
                    <Button
                        type="primary"
                        ghost
                        size="small"
                        onClick={() => handleViewVideo(record)}
                    >
                        Play Video
                    </Button>
                    <Button
                        type="default"
                        size="small"
                        onClick={() => handleDownloadVideo(record)}
                    >
                        Download
                    </Button>
                </Space>
            );
        },
    },
    {
        title: 'Jury Files',
        key: 'jury_files',
        align: 'center',
        render: (_, record) => (
            <Space>
                <Tooltip title="Upload Certificate/Comment Sheet">
                    <Button
                        size="small"
                        type="primary"
                        ghost
                        icon={<FilePdfOutlined />}
                        onClick={() => handleOpenUploadModal(record)}
                    />
                </Tooltip>
                {/* You could add indicators here if files already exist */}
                {record.certificateS3Link && <Tag color="gold">Cert</Tag>}
            </Space>
        )
    },
    {
        title: 'Avg Score',
        key: 'score',
        width: 120,
        align: 'center',
        sorter: (a, b) => parseFloat(getScoreData(a).finalPenalizedAvg || 0) - parseFloat(getScoreData(b).finalPenalizedAvg || 0),
        render: (_, record) => {
            const { avg, autoPenaltyScore, manualPenaltyScore, finalPenalizedAvg, details } = getScoreData(record);

            if (avg === '-') return <Tag>N/A</Tag>;

            // Content for the Popover (Individual Jury Breakdown)
            const content = (
                <List
                    size="small"
                    dataSource={details}
                    renderItem={item => {
                        const hasAdminAdjusted = item.adminAdjustedScore !== null && item.adminAdjustedScore !== undefined;
                        return (
                            <List.Item>
                                <div>
                                    <strong>{item.juryName}:</strong> {hasAdminAdjusted ? `${item.adminAdjustedScore} (Original: ${item.score})` : item.score}
                                    {item.comment && <div style={{ fontSize: '10px', color: '#888', maxWidth: '200px' }}>"{item.comment}"</div>}
                                    {item.panelComment && <div style={{ fontSize: '10px', color: '#aaa', maxWidth: '200px', fontStyle: 'italic' }}>Panel note: "{item.panelComment}"</div>}
                                </div>
                            </List.Item>
                        );
                    }}
                    footer={
                        (autoPenaltyScore !== 0 || manualPenaltyScore !== 0) ? (
                            <div style={{ marginTop: '8px', borderTop: '1px solid #f0f0f0', paddingTop: '8px' }}>
                                <div style={{ fontSize: '12px', fontWeight: 'bold' }}>Raw Average: {avg}</div>
                                {autoPenaltyScore !== 0 && (
                                    <div style={{ fontSize: '12px', color: '#ff4d4f' }}>
                                        Auto Penalty (Video &gt; threshold): {autoPenaltyScore}
                                    </div>
                                )}
                                {manualPenaltyScore !== 0 && (
                                    <div style={{ fontSize: '12px', color: '#ff4d4f' }}>
                                        Manual Penalty: {manualPenaltyScore}
                                    </div>
                                )}
                                <div style={{ fontSize: '12px', fontWeight: 'bold', marginTop: '4px' }}>
                                    Final Score: {finalPenalizedAvg}
                                </div>
                            </div>
                        ) : null
                    }
                />
            );

            return (
                <Popover content={content} title="Jury Breakdown" trigger="hover">
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '4px' }}>
                        <Tag
                            color={record.isScoreFinalized ? "#52c41a" : "#faad14"}
                            style={{
                                fontSize: '14px',
                                fontWeight: '800',
                                cursor: 'pointer',
                                margin: 0,
                                padding: '4px 10px',
                                borderRadius: '6px',
                                border: record.isScoreFinalized ? '1px solid #b7eb8f' : '1px solid #ffe58f',
                                boxShadow: record.isScoreFinalized ? '0 2px 0 rgba(82, 196, 26, 0.1)' : '0 2px 0 rgba(250, 173, 20, 0.1)'
                            }}
                        >
                            {record.averageScore ? Number(record.averageScore).toFixed(2) : finalPenalizedAvg}
                        </Tag>
                        {record.isScoreFinalized && (
                            <Tooltip title="Score Finalized & Locked">
                                <Tag color="success" icon={<CheckCircleFilled />} style={{ margin: 0, fontSize: '10px', borderRadius: '4px' }}>
                                    FINAL
                                </Tag>
                            </Tooltip>
                        )}
                    </div>
                </Popover>
            );
        }
    },
    {
        title: 'Result',
        key: 'finalAward',
        width: 120,
        align: 'center',
        render: (_, record) => {
            const { finalPenalizedAvg } = getScoreData(record);

            // Prefer dynamic calculation if jury scores exist, otherwise fall back to DB
            let awardToDisplay = '-';
            if (finalPenalizedAvg && finalPenalizedAvg !== '-') {
                awardToDisplay = calculateAward(finalPenalizedAvg);
            } else if (record.finalAward) {
                awardToDisplay = record.finalAward;
            }

            if (awardToDisplay !== '-') {
                let color = 'default';
                const awardStr = String(awardToDisplay).toLowerCase();
                if (awardStr.includes('sapphire')) color = 'purple';
                else if (awardStr.includes('diamond')) color = 'cyan';
                else if (awardStr.includes('gold')) color = 'gold';
                else if (awardStr.includes('silver')) color = 'geekblue';
                else if (awardStr.includes('bronze')) color = 'orange';

                return (
                    <Space direction="vertical" size={2} style={{ display: 'flex', alignItems: 'center' }}>
                        <Tag color={color} style={{ fontWeight: 700, borderRadius: '4px', textTransform: 'uppercase', margin: 0 }}>
                            {awardToDisplay}
                        </Tag>
                        {record.isScoreFinalized && (
                            <div style={{ fontSize: '10px', color: '#52c41a', display: 'flex', alignItems: 'center', gap: '2px', marginTop: '2px' }}>
                                <CheckCircleFilled style={{ fontSize: '10px' }} /> VERIFIED
                            </div>
                        )}
                    </Space>
                );
            }
            return <Tag>-</Tag>;
        }
    },
];